export default __webpack_public_path__ + "static/media/downlode.4785bf69.svg";